import {PROMOTE_NOW, PROMOTE_SOON, KEEP_ROLE, HIGH, MEDIUM, LOW} from '../utils/employees';

// Per-row palette: rows share a hue (top=green, mid=amber, bottom=red).
// Within a row the color deepens with performance (left→right).
const GREEN_LIGHT = '#D7E9C7';
const GREEN_MID   = '#B6D7A3';
const GREEN_DARK  = '#82B26F';

const AMBER_LIGHT = '#F8E5C2';
const AMBER_MID   = '#F2CC83';
const AMBER_DARK  = '#E5A340';

const RED_LIGHT   = '#F5D2CD';
const RED_MID     = '#EFB4AC';
const RED_DARK    = '#E08B82';

export const CAPACITY_CONFIG = {
    yAxisKey: 'capacity',
    rowLabels: ['promote_now', 'promote_soon', 'keep_role'],
    rows: [
        // Row 0: PROMOTE_NOW — High potential (green)
        [
            {potential: PROMOTE_NOW, performance: LOW,    label: 'enigma',                bg: GREEN_LIGHT, color: '#333'},
            {potential: PROMOTE_NOW, performance: MEDIUM, label: 'growth_employee',        bg: GREEN_MID,   color: '#333'},
            {potential: PROMOTE_NOW, performance: HIGH,   label: 'future_leader',          bg: GREEN_DARK,  color: '#333'},
        ],
        // Row 1: PROMOTE_SOON — Moderate potential (amber)
        [
            {potential: PROMOTE_SOON, performance: LOW,    label: 'dilemma',               bg: AMBER_LIGHT, color: '#333'},
            {potential: PROMOTE_SOON, performance: MEDIUM, label: 'core_employee',         bg: AMBER_MID,   color: '#333'},
            {potential: PROMOTE_SOON, performance: HIGH,   label: 'high_impact_performer', bg: AMBER_DARK,  color: '#333'},
        ],
        // Row 2: KEEP_ROLE — Limited potential (red)
        [
            {potential: KEEP_ROLE, performance: LOW,    label: 'under_performer',          bg: RED_LIGHT, color: '#333'},
            {potential: KEEP_ROLE, performance: MEDIUM, label: 'effective',                bg: RED_MID,   color: '#333'},
            {potential: KEEP_ROLE, performance: HIGH,   label: 'trusted_professional',     bg: RED_DARK,  color: '#333'},
        ],
    ],
};

export const FUTURE_POTENTIAL_CONFIG = {
    yAxisKey: 'potential_future',
    rowLabels: ['high', 'medium', 'low'],
    rows: [
        // Row 0: HIGH — High future potential (green)
        [
            {potential: HIGH, performance: LOW,    label: 'enigma',                bg: GREEN_LIGHT, color: '#333'},
            {potential: HIGH, performance: MEDIUM, label: 'growth_employee',        bg: GREEN_MID,   color: '#333'},
            {potential: HIGH, performance: HIGH,   label: 'future_leader',          bg: GREEN_DARK,  color: '#333'},
        ],
        // Row 1: MEDIUM — Moderate future potential (amber)
        [
            {potential: MEDIUM, performance: LOW,    label: 'dilemma',              bg: AMBER_LIGHT, color: '#333'},
            {potential: MEDIUM, performance: MEDIUM, label: 'core_employee',        bg: AMBER_MID,   color: '#333'},
            {potential: MEDIUM, performance: HIGH,   label: 'high_impact_performer',bg: AMBER_DARK,  color: '#333'},
        ],
        // Row 2: LOW — Low future potential (red)
        [
            {potential: LOW, performance: LOW,    label: 'under_performer',         bg: RED_LIGHT, color: '#333'},
            {potential: LOW, performance: MEDIUM, label: 'effective',               bg: RED_MID,   color: '#333'},
            {potential: LOW, performance: HIGH,   label: 'trusted_professional',    bg: RED_DARK,  color: '#333'},
        ],
    ],
};
